export default __webpack_public_path__ + "static/media/adv-embyo-lab.edcca336.jpg";